import { render, staticRenderFns } from "./BindNew.vue?vue&type=template&id=8effb222&scoped=true"
import script from "./BindNew.vue?vue&type=script&lang=js"
export * from "./BindNew.vue?vue&type=script&lang=js"
import style0 from "./BindNew.vue?vue&type=style&index=0&id=8effb222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8effb222",
  null
  
)

export default component.exports